/**
 * Transaction Payment Routes
 * @module TransactionPaymentRoutes
 * @version 1.0.0
 */

import type { RouteRecordRaw } from 'vue-router'

/**
 * Payment management routes
 */

export const paymentRoutes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: 'payments',
    component: () => import('./TransactionPaymentWrapper.vue'),
    meta: {
      title: 'Gestion des Paiements',
      requiresAuth: true,
      roles: ['admin', 'manager', 'developer'],
    },
  },
]

export default paymentRoutes
